<div class="container" class="flex-row flex-start-center gap-16">
  <vdw-ellipsis-label fxFlex="calc(100% - 44px)" [text]="orderId" matTooltipPosition="above"></vdw-ellipsis-label>
  <mat-icon class="flex-no-shrink" svgIcon="chevron-right"></mat-icon>
</div>
